import { DieselRingColors } from './productMap/constants';

// Carousel images for Diesel Ring product pages
// NOTE: Image paths are placeholders - update with actual asset paths once design team provides them
export const DieselRingCarouselData: Partial<
  Record<
    DieselRingColors,
    ReadonlyArray<Record<string, string | boolean | undefined>>
  >
> = {
  [DieselRingColors.PHANTOM]: [
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/1.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/1.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/1.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 1',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/2.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/2.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/2.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 2',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/3.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/3.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/3.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 3',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/4.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/4.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/4.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 4',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/5.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/5.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/5.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 5',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/6.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/6.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/6.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 6',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/7.png',
      srcResponsive:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/7.png',
      thumb:
        'web_v2/uh-x-diesel/buy-page/carousel-images/phantom/7.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Cryo - View 6',
    },
  ],
  [DieselRingColors.CRYO]: [
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/1.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/1.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/1.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 1',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/2.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/2.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/2.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 2',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/3.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/3.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/3.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 3',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/4.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/4.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/4.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 4',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/5.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/5.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/5.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 6',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/6.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/6.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/6.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 6',
    },
    {
      src: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/7.png',
      srcResponsive: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/7.png',
      thumb: 'web_v2/uh-x-diesel/buy-page/carousel-images/cryo/7.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Diesel Ultrahuman Ring - Phantom - View 6',
    },
  ],
};
